import { render, staticRenderFns } from "./CosmoClawDrawer.vue?vue&type=template&id=5007b1b7&scoped=true"
import script from "./CosmoClawDrawer.vue?vue&type=script&lang=js"
export * from "./CosmoClawDrawer.vue?vue&type=script&lang=js"
import style0 from "./CosmoClawDrawer.vue?vue&type=style&index=0&id=5007b1b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5007b1b7",
  null
  
)

export default component.exports